export const elIds = {
  klarna_radio_container: 'klarna-radio-container',
  stylesheet_id: 'klarna-pm-stylesheet',
};

export const uiClasses = {
  pm_container: 'klarna-pm-container',
  category_container: 'klarna-category-container',
  klarna_continue_button: 'klarna-continue-button',
  radio_container: 'klarna-radio-container',
  radio_label: 'klarna-radio-label',
  radio: 'klarna-radio',
};
